import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=e79c83ec&scoped=true"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79c83ec",
  null
  
)

export default component.exports